(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('GeonameLocalizationDialogController', GeonameLocalizationDialogController);

    GeonameLocalizationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GeonameLocalization'];

    function GeonameLocalizationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GeonameLocalization) {
        var vm = this;

        vm.geonameLocalization = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.geonameLocalization.id !== null) {
                GeonameLocalization.update(vm.geonameLocalization, onSaveSuccess, onSaveError);
            } else {
                GeonameLocalization.save(vm.geonameLocalization, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:geonameLocalizationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
